<template>
  <div class="myShopInfo" style="background: #f6f7f8">
    <van-nav-bar @click-left="onClickLeft" :border="false">
    <span slot="left" style="font-size: 17px">
       <van-icon color="black" name="arrow-left"></van-icon>
    </span>
      <span slot="title" style="font-size: 17px;color: #505050">商品详情</span>
    </van-nav-bar>
    <van-swipe :autoplay="3000" indicator-color="white">
      <van-swipe-item style="display: flex;position: relative;height: 100vw;">
         <img width="100%" style="position: relative" :src="shopInfo.goodsImg">
      </van-swipe-item>
    </van-swipe>
    <div style="padding: 0 4vw; width: 92vw;border-radius: 0 0 1.6vw 1.6vw;background: white">
      <div style="padding-top: 3.47vw;display: flex;padding-bottom: 4.8vw;">
        <div>
          <div style="font-weight: bold;font-size: 6.4vw;color: #da3939;margin-bottom: 1.3vw">
            <span style="font-size: 3.47vw">￥</span>{{$utils.priceFormat(shopInfo.price)}}
          </div>
          <div style="color: black;background: white; margin-left: 0;font-size: 4.8vw">{{shopInfo.goodsName}}</div>
        </div>
        <div></div>
      </div>
    </div>
    <div style="width: 92vw;background: white;margin: 2.4vw auto 0;font-size: 3.2vw;padding: 3.73vw 4vw 1.86vw">
      商品详情
    </div>
    <div style="width: 100vw" class="richText" v-html="shopInfo.detail"></div>
    <van-goods-action>
      <van-goods-action-icon icon="wap-home-o" text="首页" to="/myMenu/shop"></van-goods-action-icon>
<!--      <van-goods-action-icon icon="service-o" text="客服" @click="toKefu"></van-goods-action-icon>-->
      <van-goods-action-icon icon="shopping-cart-o" text="购物车" to="/myMenu/buyCart"></van-goods-action-icon>
<!--      <van-goods-action-icon-->
<!--        :icon="isCollect ? 'star' : 'star-o'"-->
<!--        :text="isCollect ? '已收藏' : '收藏'"-->
<!--        :color="isCollect ? '#ff5000' : ''"-->
<!--        @click="isCollect = !isCollect"-->
<!--      ></van-goods-action-icon>-->
      <van-goods-action-button @click="bottomClick(1)" color="#3C3C3C" style="color: white" text="加入购物车" ></van-goods-action-button>
      <van-goods-action-button @click="bottomClick(2)" color="#DE3A3A" type="danger" text="提交订单" ></van-goods-action-button>
    </van-goods-action>
    <van-popup v-model="shopShow" closeable position="bottom" round :style="{ height: '40%' }" >
      <div style="margin-top: 40px;padding: 0 5.3vw">
        <div style="display: flex;padding-bottom: 6.8vw;border-bottom: .27vw solid rgba(151, 151, 151, .17)">
          <img :src="shopInfo.goodsImg" style="width: 19.1vw;height: 19.1vw">
          <div class="shopListInfo" style="margin-left: 2.4vw">
            <div style="font-size: 3.73vw; width: 55vw; margin-top: .8vw;font-weight: bold">
              {{shopInfo.goodsName}}
              <!--          精品红油-->
            </div>
            <div style="justify-content: left;margin: 1.87vw 0 1.87vw;color: #9f9f9f;font-size: 2.67vw">
              销量: {{shopInfo.monthlySales || 0}}
            </div>
            <div  class="shopCardMoney" style="margin-bottom: 0;line-height: 5.33vw;height: 5.33vw">
              <div>
                <span style="font-size: 3.47vw;letter-spacing: -.3vw;">￥</span><span style="font-size: 5.33vw;font-weight: bold">{{$utils.priceFormat(shopInfo.price)}}</span>
              </div>
            </div>
          </div>
        </div>
        <div style="margin-top: 7.5vw;justify-content: space-between" class="centerBox">
          <div style="font-size: 3.4vw">数量</div>
          <div style="" class="shopListStepper">
            <van-stepper
              :step="shopInfo.miniBuyQty"
              v-model="shopQty"
              input-width="19.1vw"
              button-size="4.8vw"
              integer
              min="0">
            </van-stepper>
          </div>
        </div>
        <div style="margin-top: 6.3vw" @click="submitOrder">
          <div style="width: 100%;border: .2vw solid #da4e4e;color: #da3939; font-size: 3.9vw;height: 9.2vw;border-radius: 999px" class="centerBox">
            {{addType === 1 ? '加入购物车' : '提交订单'}}
          </div>
        </div>
      </div>
    </van-popup>
    <van-popup v-model="showPopup">
      <div style="padding: 5.1vw 0 3.4vw;width:60vw;text-align: center">
        <div style="color: #333333;font-size: 3.4vw;margin-bottom: 6.3vw;">订单已提交, 正在审核中</div>
        <img src="../../assets/img/confirmOrder.png" style="width: 35.3vw;margin-bottom: 6.8vw">
        <div @click="showPopup = false, $router.push('/myMenu/shopSearch')" style="background: #de3a3a;font-size: 2.9vw;border-radius: .5vw;color: white;height: 7vw;width: 23.9vw;margin: 0 auto" class="centerBox">
          继续挑选
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  name: 'shopInfo',
  data () {
    return {
      icon: {
      },
      shopQty: 0,
      current: '0',
      addType: 1,
      shopInfo: {
        minPrice: 0,
        maxPrice: 0,
        goodsImg: [],
        firstCategoryName: '',
        secondCategoryName: '',
        goodsName: '',
        tag: '',
        salesVolume: 0
      },
      selectItem: {},
      showPopup: false,
      customStepperConfig: {},
      currentQty: 0,
      selectedText: '',
      isCollect: false,
      shopShow: false,
      backShow: false,
      showCar: true,
      sku: {
        // 所有sku规格类目与其值的从属关系，比如商品有颜色和尺码两大类规格，颜色下面又有红色和蓝色两个规格值。
        // 可以理解为一个商品可以有多个规格类目，一个规格类目下可以有多个规格值。
        tree: [
        ],
        // 所有 sku 的组合列表，比如红色、M 码为一个 sku 组合，红色、S 码为另一个组合
        list: [],
        // price: '1.00', // 默认价格（单位元）
        stock_num: 0, // 商品总库存
        hide_stock: false, // 是否隐藏剩余库存
        startSaleNum: 0, // 起售数量
        quota: 0, // 当前限购数量
        limitQty: 0 // 总限购数量
      },
      goods: {
        // 默认商品 sku 缩略图
        picture: ''
      },
      initialSku: {},
      shopType: 'buyShop'
    }
  },
  created () {
    // let self = this
    this.selectGoodsInfo()
    // this.customStepperConfig = {
    //   handleStepperChange (currentValue) {
    //     self.currentQty = currentValue
    //   }
    // }
  },
  mounted () {
    // window.addEventListener('scroll', this.scrollToTop)
  },
  methods: {
    ...mapActions([
      'set_shopRow',
      'set_keepAliveList'
    ]),
    submitOrder () {
      if (this.shopQty) {
        if (this.addType === 1) {
          this.addCart()
        } else {
          this.createOrder()
        }
      }
    },
    // 结算时间
    createOrder () {
      this.$dialog.confirm({
        message: '确认要提交订单吗'
      }).then(() => {
        this.$toast.loading({
          duration: 0
        })
        const orderItemList = []
        orderItemList.push({
          goodsId: this.shopInfo.id,
          goodsName: this.shopInfo.goodsName,
          goodsPrice: this.shopInfo.price,
          qty: this.shopQty
        })
        this.$request.shopCar.createOrder({
          orderItemList,
          orderPrice: this.shopInfo.price * this.shopQty,
          remark: ''
        })
          .then((response) => {
            if (response.code === '200') {
              this.$toast.clear()
              this.showPopup = true
            } else {
              this.$toast(response.msg)
            }
          })
          .catch((error) => {
            console.log(error)
          })
      })
    },
    // 开始加入购物车了~~~~~
    addCart () {
      console.log(this.shopInfo)
      const self = this
      self.$toast.loading({
        duration: 0
      })
      if (this.selectItem.buyQty) {
        this.changeCartGoodsNum()
        return
      }
      self.$request.shop.addCartGoods({
        qty: this.shopQty,
        ...this.shopInfo
      })
        .then((response) => {
          self.$toast.clear()
          if (response.code === '200') {
            self.$toast({
              message: '已成功加入购物车',
              icon: this.icon.successIcon
            })
            self.shopShow = false
          } else {
            // console.log(response)
            self.$toast(response.msg)
          }
        })
    },
    // 第二次加购物车喽~~~~~~~
    changeCartGoodsNum () {
      console.log('二次')
      this.$toast.loading({
        duration: 0
      })
      let opFlag = 0
      let chaNumber = 0
      console.log(this.shopQty)
      console.log(this.selectItem.buyQty)
      if (this.shopQty > this.selectItem.buyQty) {
        opFlag = 1
        chaNumber = Number(this.shopQty) - Number(this.selectItem.buyQty)
      } else if (this.shopQty < this.selectItem.buyQty) {
        opFlag = 2
        chaNumber = Number(this.selectItem.buyQty) - Number(this.shopQty)
      } else {
        opFlag = 3
        chaNumber = ''
      }
      this.$request.shop.changeCartGoodsNum({
        goodsId: this.shopInfo.id,
        category: this.shopInfo.category,
        miniBuyQty: chaNumber,
        minCartGoodsList: this.shopInfo.minCartGoodsList,
        opFlag: opFlag
      })
        .then((response) => {
          this.$toast.clear()
          if (response.code === '200') {
            this.$toast({
              message: '已成功加入购物车',
              icon: this.icon.successIcon
            })
            this.shopShow = false
          } else {
            this.$toast(response.msg)
          }
        })
        .catch((error) => {
          console.log(error)
        })
    },
    scrollToTop () {
      const top = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      if (top < 0) {
        window.pageYOffset = document.documentElement.scrollTop = document.body.scrollTop = 0
      }
      this.backShow = top > 400
    },
    toKefu () {
      const productInfo = {
        visible: true,
        actionText: '发送',
        actionTextColor: '#fff',
        title: this.shopInfo.goodsName,
        sub_title: this.selectedText.replace('已选', ''),
        other_title_one: this.shopInfo.firstCategoryName || '',
        other_title_two: this.shopInfo.secondCategoryName || '',
        // 'other_title_three': '',
        img: encodeURIComponent(this.shopInfo.imgPath),
        price: '￥' + this.shopInfo.minPrice / 100 + (this.shopInfo.minPrice === this.shopInfo.maxPrice ? '' : ('-￥' + this.shopInfo.maxPrice / 100)),
        // 'attr_one': {'color': '#000000', 'content': 'X1'},
        // 'attr_two': {'color': '#000000', 'content': '已发货'},
        target: encodeURIComponent(this.$utils.baseURL() + '/#/shopInfo?id=' + this.shopInfo.id),
        time: 'agent',
        showCardInfoMsg: 1
      }
      this.$router.push({
        path: '/kefu',
        query: {
          productInfo: JSON.stringify(productInfo)
        }
      })
    },
    onClickLeft () {
      this.$router.go(-1)
    },
    bottomClick (shopType) {
      let b = 1
      // const data = new Date().getTime() + ''
      // if (data > window.localStorage.getItem('orderStartTime') && data < window.localStorage.getItem('orderEndTime')) {
      // } else {
      //   this.$toast('未在下单时间范围内')
      //   b--
      // }
      if (b) {
        this.shopQty = 0
        this.selectGoodsInfo()
        this.shopShow = true
        this.addType = shopType
      }
    },
    skuSelected (skuValue) {
      this.selectedText = this.$refs.sku.selectedText
      if (skuValue.selectedSkuComb) {
        this.sku.startSaleNum = skuValue.selectedSkuComb.buyNumMin || 0
        this.sku.quota = this.sku.limitQty > skuValue.selectedSkuComb.buyNumMax || this.sku.limitQty === 0 ? skuValue.selectedSkuComb.buyNumMax : this.sku.limitQty
      } else {
        this.sku.quota = this.sku.limitQty
      }
    },
    selectGoodsInfo () {
      this.$toast.loading()
      this.$request.shop.shopGetById(this.$route.query.id)
        .then((response) => {
          this.$toast.clear()
          this.shopInfo = response.data
          if (response.data.buyQty) {
            this.shopQty = response.data.buyQty
          }
          this.selectItem = response.data
        })
        .catch((error) => {
          console.log(error)
        })
    },
    toComment () {
      this.$router.push('/comment')
    },
    backTop () {
      const top = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      setTimeout(() => {
        window.pageYOffset = document.documentElement.scrollTop = document.body.scrollTop = top - 100
        if (top > 0) {
          this.backTop()
        }
      }, 10)
    }
  }
}
</script>

<style>
  .myShopInfo .van-cell__title {
    flex: 4;
  }
  .myShopInfo .van-cell__value {
    flex: 2;
  }
  .seckillInfoRight {
    font-size: 2.93vw;
    border-radius: 1.33vw;
    color: white;
    position: relative;
    font-family: DIN_Medium;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 5.33vw;
    height: 5.33vw;
  }
  .seckillInfoRight div {
    margin-top: .6vw;
  }
  .seckillInfoRightMH div {
    margin-top: .3vw;
  }
  .seckillInfoRightMH {
    font-weight: bold;
    position: relative;
    font-size: 2.93vw;
    margin: 0 .47vw;
    display: inline-block;
    height: 5.33vw;
    line-height: 5.33vw;
    font-family: DIN_Medium;
  }
</style>
